import React from 'react';
import { useParams } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import MainLayout from '../../components/Layout/MainLayout';
import BookCard from '../../components/shared/BookCard';
import SectionTitle from '../../components/shared/SectionTitle';
import EmptyState from '../../components/shared/EmptyState';
import { useApi } from '../../hooks/useApi';

import {
  PageWrapper,
  AuthorHeader,
  AuthorImage,
  AuthorImagePlaceholder,
  AuthorInfo,
  AuthorName,
  AuthorBio,
  BooksSection,
  BooksGrid,
} from './styles';

export default function Author() {
  const { id } = useParams();
  const { data: author, loading } = useApi(`/authors/${id}`);

  if (loading) {
    return (
      <MainLayout showSidebar={false}>
        <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />
      </MainLayout>
    );
  }

  if (!author) {
    return (
      <MainLayout showSidebar={false}>
        <PageWrapper>
          <EmptyState description="Autor no encontrado" actionText="Volver al inicio" actionLink="/" />
        </PageWrapper>
      </MainLayout>
    );
  }

  const authorBooks = author.books || [];

  return (
    <MainLayout showSidebar={false}>
      <PageWrapper>
        <AuthorHeader>
          <AuthorImage>
            {author.image ? (
              <img src={author.image} alt={author.name} />
            ) : (
              <AuthorImagePlaceholder>
                <UserOutlined />
              </AuthorImagePlaceholder>
            )}
          </AuthorImage>
          <AuthorInfo>
            <AuthorName>{author.name}</AuthorName>
            <AuthorBio>{author.bio}</AuthorBio>
          </AuthorInfo>
        </AuthorHeader>

        <BooksSection>
          <SectionTitle title="Libros del autor" />
          {authorBooks.length > 0 ? (
            <BooksGrid>
              {authorBooks.map((book) => (
                <BookCard
                  key={book.id}
                  id={book.id}
                  title={book.title}
                  author={book.authorName}
                  price={book.price}
                  originalPrice={book.originalPrice}
                  condition={book.condition}
                  coverImage={book.coverImage}
                  showAddToCart
                />
              ))}
            </BooksGrid>
          ) : (
            <EmptyState description="No se encontraron libros de este autor" />
          )}
        </BooksSection>
      </PageWrapper>
    </MainLayout>
  );
}
